import styled from '@emotion/styled'

import { LinkButton, MessageBox, Space, Typography } from '../../atoms'

export type TradeApproveReadonlyProps = {
  waitingDescription: string
}

const StyledLink = styled.section``

const TradeApproveReadonly = ({ waitingDescription }: TradeApproveReadonlyProps) => {
  const onShowApprovalProcess = () => {
    // Todo:
  }

  return (
    <MessageBox state="disabled">
      <Space mb={4}>
        <Typography data-private variant="b3">
          {waitingDescription}
        </Typography>
      </Space>
      <StyledLink>
        <LinkButton underline={false} onClick={onShowApprovalProcess}>
          Learn more about the approval process
        </LinkButton>
      </StyledLink>
    </MessageBox>
  )
}

export default TradeApproveReadonly
